import React, { useState } from "react";
import { toast } from "sonner";
import { Lock } from "lucide-react";
import { api } from "@/lib/api";

export default function ChangePasswordPanel() {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (next.length < 8) {
      toast.error("New password must be at least 8 characters");
      return;
    }
    if (next !== confirm) {
      toast.error("Passwords do not match");
      return;
    }
    setSaving(true);
    try {
      await api.post("/auth/change-password", {
        current_password: current,
        new_password: next,
      });
      toast.success("Password updated.");
      setCurrent("");
      setNext("");
      setConfirm("");
    } catch (err) {
      const detail = err?.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Could not update password");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="panel" data-testid="change-password-panel">
      <div className="border-b border-zinc-900 px-5 py-3 flex items-center gap-2">
        <Lock className="w-3.5 h-3.5 text-[#FFB000]" />
        <span className="font-mono text-[11px] uppercase tracking-widest">// CHANGE PASSWORD</span>
      </div>
      <form onSubmit={submit} className="p-5 space-y-4 max-w-md">
        <p className="font-mono text-[11px] text-zinc-500 leading-relaxed">
          Update the password for your DARA account. You&apos;ll stay logged in on this device.
        </p>

        <label className="block">
          <span className="font-mono text-[10px] uppercase tracking-widest text-zinc-500">Current password</span>
          <input
            data-testid="change-password-current-input"
            type="password"
            required
            value={current}
            onChange={(e) => setCurrent(e.target.value)}
            className="mt-2 w-full bg-black border border-zinc-800 px-3 py-2.5 font-mono text-sm text-white focus:outline-none focus:border-[#FFB000]"
          />
        </label>
        <label className="block">
          <span className="font-mono text-[10px] uppercase tracking-widest text-zinc-500">New password</span>
          <input
            data-testid="change-password-new-input"
            type="password"
            required
            minLength={8}
            value={next}
            onChange={(e) => setNext(e.target.value)}
            className="mt-2 w-full bg-black border border-zinc-800 px-3 py-2.5 font-mono text-sm text-white focus:outline-none focus:border-[#FFB000]"
          />
        </label>
        <label className="block">
          <span className="font-mono text-[10px] uppercase tracking-widest text-zinc-500">Confirm new password</span>
          <input
            data-testid="change-password-confirm-input"
            type="password"
            required
            minLength={8}
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            className="mt-2 w-full bg-black border border-zinc-800 px-3 py-2.5 font-mono text-sm text-white focus:outline-none focus:border-[#FFB000]"
          />
        </label>

        <button
          type="submit"
          disabled={saving || !current || !next || !confirm}
          data-testid="change-password-submit-btn"
          className="bg-[#FFB000] text-black font-bold font-mono text-[11px] uppercase tracking-widest px-5 py-2.5 hover:bg-[#E59E00] transition-colors disabled:opacity-50"
        >
          {saving ? "UPDATING…" : "UPDATE PASSWORD"}
        </button>
      </form>
    </div>
  );
}
